import { render, staticRenderFns } from "./0-member-profile-extras.vue?vue&type=template&id=444dedce&scoped=true"
import script from "./0-member-profile-extras.vue?vue&type=script&lang=js"
export * from "./0-member-profile-extras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444dedce",
  null
  
)

export default component.exports